import {
  establishSecureChannel,
  HANDSHAKE_TIMEOUT_MS,
  type CardViewerHandshakeError,
  type SecureChannelFailure,
} from "@highnoteplatform/types";

import { iframeOrigin, packageName, packageVersion } from "./config";

export { HANDSHAKE_TIMEOUT_MS };

const FAILURE_MESSAGES: Record<SecureChannelFailure, string> = {
  FRAME_UNREACHABLE:
    "Unable to reach the card viewer frame. Please try again or contact support.",
  HANDSHAKE_TIMEOUT:
    "Card viewer frame did not respond. Please try again or contact support.",
};

interface EstablishCardViewerChannelConfig {
  frame: HTMLIFrameElement;
  uuid: string;
  clientToken: string;
  paymentCardId: string;
  onError: (error: CardViewerHandshakeError) => void;
  onHandshakeAck?: () => void;
}

// Card-viewer facade over the shared secure-channel machinery: same call
// shape the SDK has used since DX-8174, with failures mapped to the public
// CardViewerHandshakeError wording.
export const establishCardViewerChannel = ({
  frame,
  uuid,
  clientToken,
  paymentCardId,
  onError,
  onHandshakeAck,
}: Readonly<EstablishCardViewerChannelConfig>): (() => void) =>
  establishSecureChannel({
    frame,
    iframeOrigin,
    uuid,
    clientToken,
    paymentCardId,
    sdkName: packageName,
    sdkVersion: packageVersion,
    onHandshakeAck,

    onFailure: (failure) => {
      onError({
        name: "CardViewerHandshakeError",
        message: FAILURE_MESSAGES[failure],
      });
    },
  });
